import { FlexBox, Text, Tooltip } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import { ampli } from 'lib-shared-tracking';
import moment from 'moment-timezone';
import { memo, useMemo } from 'react';

import { AppLink } from 'components/appLink';
import { useAppSelector } from 'utils/redux/useAppSelector';

import styles from './dashboardHeartbeat.module.scss';

export const DashboardHeartbeat = memo(
  function DashboardHeartbeat(): JSX.Element {
    const hasOrganizationInfoAccess = useHasAccess('organization.info');

    const organization = useAppSelector(
      (state) => state.settings.organizationV2.organization,
    );
    const timezone = organization?.timezone ?? 'UTC';
    const offset = moment.tz(timezone).format('Z');

    const tooltipContent = useMemo(
      (): JSX.Element => (
        <FlexBox flexDirection="column" gap="200" alignItems="center">
          <Text.Paragraph color="inherit" align="center">
            This dashboard resets daily{' '}
            {timezone === 'UTC' ? (
              'in UTC.'
            ) : (
              <>
                according to your organization&apos;s timezone:{' '}
                <b>
                  {timezone} ({offset})
                </b>
              </>
            )}
          </Text.Paragraph>

          {hasOrganizationInfoAccess && (
            <Text.Paragraph color="inherit" align="center">
              You can set your preferred organization timezone in{' '}
              <AppLink
                path="/settings/organization"
                onClick={() => {
                  ampli.dashboardOrganizationTimezoneSettingsClicked();
                }}
              >
                <Text.ExternalLink as="span">
                  Settings / Organization
                </Text.ExternalLink>
              </AppLink>
              .
            </Text.Paragraph>
          )}
        </FlexBox>
      ),
      [timezone, offset, hasOrganizationInfoAccess],
    );

    return (
      <Tooltip
        className={styles.tooltip}
        content={tooltipContent}
        requireClick
        side="right"
      >
        <div className={styles.heartbeat} />
      </Tooltip>
    );
  },
);
